(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[118],{

/***/ 1937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submissions",
      function () {
        return __webpack_require__(2334);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ submissions; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.1.0_61390be992b634a688f7c2555547b55b/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(6351);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.3.1_react@17.0.2/node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(999);
// EXTERNAL MODULE: ./src/ui/components/LocationInfo/index.tsx + 1 modules
var LocationInfo = __webpack_require__(5119);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/styles/submissions/index.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n margin: 2vh 2vw;\n\n @media (max-width: 426px) {\n  padding: 2vh 4vw 3vh 4vw;\n }\n\n > div {\n  background: #ddd;\n  padding: 2.8vh 1.3vw;\n  border-left: 5px solid #479;\n }\n\n h2,\n h3 {\n  font-variant: small-caps;\n  font-stretch: 110%;\n  color: #f70;\n }\n h2 {\n  margin: 2vh 0;\n }\n h3 {\n  margin: 1vh 0;\n }\n\n p,\n span {\n  line-height: 1.5em;\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n margin-top: 4vh;\n\n ol {\n  margin: 2vh 0;\n\n  > li {\n   position: relative;\n   padding: 3vh 3vw;\n   border: 1px solid #ddd;\n\n   @media (max-width: 426px) {\n    padding: 3vh 15%;\n   }\n\n   ul {\n    list-style-type: disc;\n   }\n\n   svg {\n    color: #0f0;\n    position: absolute;\n    left: 1.5%;\n    top: 50%;\n    transform: translate(0, -50%);\n\n    @media (max-width: 426px) {\n     left: 3%;\n    }\n   }\n  }\n }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n > ol {\n  list-style-type: none;\n  counter-reset: item;\n\n  > li {\n   counter-increment: item;\n   margin-bottom: 2vh;\n\n   &:before {\n    content: counters(item, '.') '. ';\n   }\n\n   &:before,\n   > span {\n    font-weight: 700;\n    color: #f70;\n   }\n  }\n }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n list-style-type: none;\n counter-reset: item;\n line-height: 1.5em;\n\n > li {\n  counter-increment: item;\n\n  ul {\n   list-style: none;\n   margin-bottom: 1vh;\n   margin-left: 1vw;\n\n   li {\n    margin-bottom: 1vh;\n   }\n  }\n\n  &:before {\n   content: counters(item, '.') ' ';\n  }\n }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n ul {\n  list-style: none;\n }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var Styling = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7544c860-0"
})(_templateObject());
var Conditions = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-7544c860-1"
})(_templateObject1());
var Guidelines = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-7544c860-2"
})(_templateObject2());
var SubList = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    componentId: "sc-7544c860-3"
})(_templateObject3());
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-7544c860-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/pages/submissions/index.tsx






var description = 'Diretrizes para submiss\xe3o de pap\xe9is para a revista.';
var title = 'Submiss\xf5es';
var Submission = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                description: description,
                openGraph: {
                    description: description,
                    title: title
                },
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationInfo/* default */.Z, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styling, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://periodicos.ufpb.br/ojs2/index.php/arf/submission/wizard",
                                    children: "Fazer nova submiss\xe3o"
                                }),
                                ' ou ',
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://periodicos.ufpb.br/ojs2/index.php/arf/submissions",
                                    children: "ver suas submiss\xf5es pendentes"
                                }),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Conditions, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Condi\xe7\xf5es para submiss\xe3o"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Como parte do processo de submiss\xe3o, os autores s\xe3o obrigados a verificar a conformidade da submiss\xe3o em rela\xe7\xe3o a todos os itens listados a seguir. As submiss\xf5es que n\xe3o estiverem de acordo com as normas ser\xe3o devolvidas aos autores."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCheck */.l_A, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "A contribui\xe7\xe3o \xe9: ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "original e in\xe9dita"
                                                    }),
                                                    " e",
                                                    ' ',
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "n\xe3o est\xe1 sendo simultaneamente submetida para avalia\xe7\xe3o e publica\xe7\xe3o a outra revista"
                                                    }),
                                                    ". Caso esteja, deve-se justificar em \"Coment\xe1rios ao editor\" a atual situa\xe7\xe3o da submiss\xe3o."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCheck */.l_A, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "O arquivo da submiss\xe3o est\xe1 em formato Microsoft Word, LibreOffice ou RTF."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCheck */.l_A, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "URLs para as refer\xeancias foram informadas quando poss\xedvel."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCheck */.l_A, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "O arquivo de texto:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "tem espa\xe7o de 1,5 e fonte de tamanho 12"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                "emprega ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    children: "it\xe1lico"
                                                                }),
                                                                " ao inv\xe9s de ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                                                    children: "sublinhado"
                                                                }),
                                                                " (exceto em endere\xe7os URL)"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                "emprega ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    children: "it\xe1lico"
                                                                }),
                                                                " ao inv\xe9s de ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                    children: "negrito"
                                                                }),
                                                                " em todas as partes do texto, incluindo as refer\xeancias"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "tem suas figuras e tabelas inseridas no pr\xf3prio texto, quando for o caso"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "todos os t\xedtulos e subt\xedtulos est\xe3o em fonte normal (n\xe3o est\xe3o em caixa alta/letra mai\xfascula)"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCheck */.l_A, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "O texto segue os padr\xf5es de estilo e requisitos bibliogr\xe1ficos descritos em",
                                                    ' ',
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "#diretrizes",
                                                        children: "Diretrizes para Autores"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCheck */.l_A, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "Em caso de submiss\xe3o a uma se\xe7\xe3o com avalia\xe7\xe3o pelos pares, (ex.: Se\xe7\xe3o ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        children: "Artigos"
                                                    }),
                                                    ") as instru\xe7\xf5es dispon\xedveis em ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "/submissions/blind_review",
                                                        children: "Assegurando a Avalia\xe7\xe3o pelos Pares Cega"
                                                    }),
                                                    " foram seguidas."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCheck */.l_A, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "A submiss\xe3o inclui todos os dados pessoais do Formul\xe1rio de Cadastro no site da Revista, tais como:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "afilia\xe7\xe3o institucional;"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "titula\xe7\xe3o;"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "endere\xe7o;"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "e-mail;"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "biografia resumida"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "dados de coautores, quando for o caso"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCheck */.l_A, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "O autor oferece:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            "um link para a confirma\xe7\xe3o das informa\xe7\xf5es de CV (",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                children: "Curriculum vitae"
                                                            }),
                                                            ") na Plataforma de Curr\xedculo LATES, dispens\xe1vel para autores estrangeiros sem v\xednculo institucional ou com pesquisas financiadas no Brasil"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "um link de registro na Plataforma ORCID."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "O nome de autor usado na submiss\xe3o deve ser o mesmo usado nos registros p\xfablicos dessas plataformas."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Guidelines, {
                        id: "diretrizes",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Diretrizes para Autores"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Formata\xe7\xe3o"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubList, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "O manuscrito deve ter o formato .doc, .rtf ou .odt, nunca .pdf, e conter entre 15 e 25 laudas. O tamanho da p\xe1gina deve ser A4. As margens esquerda e superior de 3 cm e direita e inferior de 2 cm. O espa\xe7amento entre as linhas deve ser de 1.5 pt. A fonte geral deve ser Times New Roman, de tamanho 12 pt. As notas de rodap\xe9, assim como cita\xe7\xf5es, devem ser formatadas automaticamente, com tamanho 10 pt. T\xedtulos e subt\xedtulos devem estar em negrito."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "O manuscrito deve conter as seguintes partes: t\xedtulo; resumo, acompanhado de 3 a 5 palavras-chave; tradu\xe7\xf5es para ingl\xeas; corpo do artigo; e refer\xeancias bibliogr\xe1ficas. Nota: os dados relativos \xe0s credenciais do autor devem ser enviados em arquivo separado, conforme instru\xeddo no item 2 abaixo."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "O manuscrito deve ser ser original ou de revis\xe3o liter\xe1ria que atualize o estado da arte do tema, tratar de tem\xe1tica na \xe1rea de Filosofia ou possuir vincula\xe7\xe3o com a \xe1rea filos\xf3fica. Deve cumprir crit\xe9rios gerais de qualidade e formata\xe7\xe3o, primando pela \xe9tica na publica\xe7\xe3o cient\xedfica."
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Procedimentos para submiss\xe3o"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubList, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Para submeter um artigo, o autor precisa criar uma conta na revista, cujo cadastro \xe9 permanente e servir\xe1 para futuras submiss\xf5es, bem como acompanhamento de todo o processo de submiss\xe3o do artigo."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "No ato da submiss\xe3o do artigo, o autor deve enviar uma c\xf3pia do artigo sem identifica\xe7\xe3o e um arquivo com suas credenciais como documento suplementar."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Ao concluir o processo de submiss\xe3o, o autor receber\xe1 automaticamente um e-mail de confirma\xe7\xe3o. Este email ser\xe1 o documento comprovat\xf3rio de submiss\xe3o, e servir\xe1 para os protocolos oficiais de comprova\xe7\xe3o para curr\xedculo."
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Processo de avalia\xe7\xe3o e parecer"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Os manuscritos ser\xe3o avaliados pelo processo de",
                                                    ' ',
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "/submissions/blind_review",
                                                        children: "avalia\xe7\xe3o cega dupla pelos pares"
                                                    }),
                                                    " (double blind peer review). Os avaliadores podem ser membros do Conselho da Revista ou membros “ad hoc” escolhidos na Plataforma Lattes/CNPq pelo crit\xe9rio de titula\xe7\xe3o acad\xeamica igual ou superior \xe0 do autor avaliado, preferencialmente ligado a programa de p\xf3s-gradua\xe7\xe3o com pesquisa na \xe1rea. Revis\xf5es sugeridas de forma ou conte\xfado devem ser providenciadas pelos autores no prazo estabelecido pela revista. O prazo desejado para avalia\xe7\xe3o dos textos \xe9 de at\xe9 30 dias. Textos reprovados n\xe3o podem ser submetidos novamente para avalia\xe7\xe3o."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Modelos para elabora\xe7\xe3o de refer\xeancias"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubList, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "As refer\xeancias devem constar em ordem alfab\xe9tica pelo sobrenome do primeiro autor."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Os t\xedtulos de peri\xf3dicos dever\xe3o ser escritos por extenso, e nunca devem ser abreviados."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Exemplos:"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                    children: "Livro com 1~3 autores"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    "SOBRENOME, Nome. ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "T\xedtulo da obra"
                                                                                    }),
                                                                                    ". Edi\xe7\xe3o. Local: Editora, data. Volume ou total de p\xe1ginas. (S\xe9rie ou Cole\xe7\xe3o)"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                        children: "Obs: "
                                                                                    }),
                                                                                    "Em documentos com at\xe9 3 autores, indicar os tr\xeas separados por “;” (ponto e v\xedrgula). Nunca utilizar \"e\", \"and\" ou \"&\";"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                    children: "Livro com mais de 3 autores"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    "SOBRENOME1, Nome1 et al. ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "T\xedtulo da obra"
                                                                                    }),
                                                                                    ". Edi\xe7\xe3o. Local: Editora, data. Volume ou total de p\xe1ginas. (S\xe9rie ou Cole\xe7\xe3o)"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                    children: "Cap\xedtulo de livro"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    "SOBRENOME, Nome. T\xedtulo do cap\xedtulo: subt\xedtulo. In: SOBRENOME, Nome. ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "T\xedtulo da obra"
                                                                                    }),
                                                                                    ". Local: Editora, data. P\xe1ginas inicial-final do cap\xedtulo."
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                    children: "Disserta\xe7\xf5es e Teses"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "SOBRENOME, Nome. T\xedtulo da tese ou disserta\xe7\xe3o: subt\xedtulo. Data de defesa. Total de p\xe1ginas ou folhas. Disserta\xe7\xe3o ou Tese (Mestrado ou Doutorado em \xe1rea de concentra\xe7\xe3o) - Departamento ou Centro, Institui\xe7\xe3o, Local, ano de defesa."
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                    children: "Trabalho apresentado em congressos, simp\xf3sios e similares"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    "SOBRENOME, Nome. T\xedtulo do trabalho. In: ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "T\xedtulo do evento"
                                                                                    }),
                                                                                    ", n\xba, data, local de realiza\xe7\xe3o. Canais... ou Resumos... ou Proceedings... Local de publica\xe7\xe3o: Editora, data. P\xe1ginas inicial-final do trabalho."
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                        children: "Obs: "
                                                                                    }),
                                                                                    "Em documentos com at\xe9 3 autores, indicar os tr\xeas separados por “;” (ponto e v\xedrgula). Nunca utilizar \"e\", \"and\" ou \"&\";"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                    children: "Trabalhos acad\xeamicos e apostilas"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    "SOBRENOME, Nome. ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "T\xedtulo"
                                                                                    }),
                                                                                    ": subt\xedtulo. Local: Departamento, data. N\xfamero de p\xe1ginas."
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                        children: "Obs:"
                                                                                    }),
                                                                                    " Trabalho de Conclus\xe3o de Curso ou Trabalho de Gradua\xe7\xe3o ou Relat\xf3rio de Est\xe1gio ou Apostila."
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                    children: "Publica\xe7\xf5es peri\xf3dicas (revistas cient\xedficas em geral, jornais)"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    "SOBRENOME, Nome. T\xedtulo do artigo. ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "T\xedtulo do peri\xf3dico"
                                                                                    }),
                                                                                    ", Local, volume, n\xfamero, p\xe1ginas inicial-final do artigo, data."
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                    children: "Sites da Internet"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    "SOBRENOME, Nome ou AUTORIA INSTITUCIONAL. ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "T\xedtulo"
                                                                                    }),
                                                                                    ". Dispon\xedvel em: endere\xe7o eletr\xf4nico. Acesso em: data."
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Notas E Cita\xe7\xf5es"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Devem seguir a NBR 10520/2002 - ABNT, cujo guia para padroniza\xe7\xe3o de cita\xe7\xf5es est\xe1 dispon\xedvel",
                                                    ' ',
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "https://www.bco.ufscar.br/arquivos/manual-bco-nbr-10520-2002.pdf",
                                                        children: "neste link"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Preven\xe7\xe3o contra pl\xe1gio e outros"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Todos os originais apresentados s\xe3o previamente submetidos a motores de verifica\xe7\xe3o de pl\xe1gio. Em casos de percentagem superior a 40% os autores s\xe3o convidados a se manifestarem sobre. A veracidade de fontes, conceitos e opini\xf5es emitidos nos artigos s\xe3o de responsabilidade dos autores."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Se\xe7\xf5es aplic\xe1veis para submiss\xf5es"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Editorial"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Se\xe7\xe3o administrada exclusivamente pelo editor principal e/ou editores especiais."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Artigos"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Os artigos submetidos para esta se\xe7\xe3o devem ser in\xe9ditos e, preferencialmente, resultado de pesquisas ou revis\xf5es acad\xeamicas relacionadas aos projetos de pesquisa dos autores. Devem estar relacionados com a \xe1rea de abrang\xeancia da revista (Filosofia) ou \xe1reas interdisciplinares, ou ainda versarem sobre uma livre revis\xe3o do estado da arte de temas considerados relevantes a partir das \xe1reas de pesquisa dos autores, em particular. Todas as submiss\xf5es devem seguir o padr\xe3o descrito nas ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "#diretrizes",
                                                        children: "diretrizes para autores"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Entrevistas"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Se\xe7\xe3o destinada \xe0 publica\xe7\xe3o de entrevistas com pesquisadores de destaque na \xe1rea acad\xeamica da revista, sobre temas de interesse para a comunidade filos\xf3fica que versem sobre quest\xf5es da atualidade ou de pertin\xeancia hist\xf3rica, ou considerados relevantes para a pesquisa filos\xf3fica em geral. Ela visa dar espa\xe7o a um debate prof\xedcuo e atualizado que, por vezes, s\xe3o dif\xedceis de serem sistematizados em forma de artigo ou ensaio."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Apresenta\xe7\xe3o: As entrevistas devem conter um resumo em portugu\xeas e ingl\xeas, palavras-chave e keywords, al\xe9m de uma apresenta\xe7\xe3o do auto/tema da entrevista. O texto dever\xe1 conter a mesma formata\xe7\xe3o para artigos, descrita nas",
                                                    ' ',
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "#diretrizes",
                                                        children: "diretrizes para autores"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Tradu\xe7\xf5es"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Se\xe7\xe3o destinada \xe0 tradu\xe7\xe3o de textos in\xe9ditos na \xe1rea acad\xeamica da revista, ou considerados relevantes para a pesquisa filos\xf3fica em geral. Ela visa dar um suporte \xe0 aus\xeancia de tradu\xe7\xf5es sistem\xe1ticas de textos de uso corrente em outras l\xednguas que, por motivos diversos, tardam em aparecer traduzidos para a l\xedngua portuguesa. As tradu\xe7\xf5es devem estar sempre acompanhadas de: suas publica\xe7\xf5es originais; e uma autoriza\xe7\xe3o expressa, em PDF, do autor/editora detentor dos direitos autorais, quando for o caso. Deve conter, no m\xe1ximo, 30 p\xe1ginas, mas casos extras podem ser analisados. O texto ser\xe1 apreciado por um revisor do conselho editorial conhecedor da l\xedngua traduzida."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Apresenta\xe7\xe3o: \xc9 necess\xe1rio um resumo/coment\xe1rio breve (de at\xe9 100 palavras e 3 palavras-chaves) e suas tradu\xe7\xf5es para o ingl\xeas. Deve seguir tamb\xe9m a mesma formata\xe7\xe3o para artigos, descritos nas",
                                                    ' ',
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "#diretrizes",
                                                        children: "diretrizes para autores"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Resenhas"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Esta se\xe7\xe3o tem por objetivo a apresenta\xe7\xe3o cr\xedtica de obras relevantes na \xe1rea de filosofia. A obra resenhada deve ter sido publicada h\xe1, no m\xe1ximo, 5 anos, preferivelmente. Exce\xe7\xf5es ser\xe3o consideradas e podem ser justificadas pela relev\xe2ncia da obra. Deve apresentar, al\xe9m de uma descri\xe7\xe3o regular da obra, mas n\xe3o necessariamente, uma inten\xe7\xe3o cr\xedtica com as posi\xe7\xf5es defendidas pelo autor da obra resenhada."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Forma de apresenta\xe7\xe3o: O texto deve ter um t\xedtulo, um resumo/coment\xe1rio breve (de at\xe9 100 palavras e de 3 a 5 palavras-chaves) e suas tradu\xe7\xf5es para o ingl\xeas (t\xedtulo, resumo e palavras-chave)."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Declara\xe7\xe3o de Direito Autoral"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Pol\xedtica de Direito Autoral para os itens publicados pela Revista:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "Esta revista \xe9 regida por uma licen\xe7a da Creative Commons aplicada a revistas eletr\xf4nicas. Esta licen\xe7a pode ser lida no link a seguir:",
                                                ' ',
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "https://creativecommons.org/licenses/by/4.0/",
                                                    children: "Creative Commons Attribution 4.0 International"
                                                }),
                                                ' ',
                                                "(CC BY 4.0)."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Consonante a essa politica, a revista declara que os autores s\xe3o os detentores do copyright de seus artigos sem restri\xe7\xe3o, e podem depositar o p\xf3s-print de seus artigos em qualquer reposit\xf3rio ou site."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Pol\xedtica de Direito de Uso dos Metadados para informa\xe7\xf5es contidas nos itens do reposit\xf3rio:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Qualquer pessoa e/ou empresa pode acessar os metadados dos itens publicados gratuitamente e a qualquer tempo."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "Os metadados podem ser usados sem licen\xe7a pr\xe9via em qualquer meio, mesmo comercialmente, desde que seja oferecido um link para o ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: "OAI Identifier"
                                                }),
                                                " ou para o artigo que ele descreve, sob os termos da licen\xe7a CC BY aplicada \xe0 revista."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Os autores que t\xeam seus trabalhos publicados concordam que com todas as declara\xe7\xf5es e normas da Revista e assumem inteira responsabilidade pelas informa\xe7\xf5es prestadas e ideias veiculadas em seus artigos, em conformidade com a Pol\xedtica de Boas Pr\xe1ticas da Revista."
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var submissions = (Submission);


/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LocationInfo; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.0.10_react-dom@17.0.2+react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(1999);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/styles.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n font-size: 0.9em;\n margin: 2vh 2vw;\n\n @media (max-width: 462px) {\n  margin: 2vh 4vw;\n }\n\n span:last-of-type {\n  color: #f70;\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba06a0ec-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/index.tsx




var LocationInfo = function(param) {
    var children = param.children;
    var pathname = (0,router.useRouter)().pathname;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: "/",
                children: "In\xedcio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: " / "
            }),
            pathname.match(/\/issues.+/) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "/issues",
                    children: "Arquivos / "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    }));
};
/* harmony default export */ var components_LocationInfo = (LocationInfo);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,888,179], function() { return __webpack_exec__(1937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);